import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface IOperationalStatus {
    overallStatus: {
        isOperationalState: boolean;
    };
}

interface IGetOperationalStatusRequest {
    statusPageId: string;
    signal?: AbortSignal;
}
const getOperationalStatus = async ({ statusPageId, signal }: IGetOperationalStatusRequest): Promise<IOperationalStatus | undefined> => {
    const source = axios.CancelToken.source();

    if (signal) {
        signal.addEventListener('abort', () => {
            source.cancel('Query was canceled');
        });
    }
    const response = await axios.post<IOperationalStatus>(`https://oneuptime.com/status-page-api/overview/${statusPageId}`, { cancelToken: source.token });
    return response.data;
};

const useGetOperationalStatus = (statusPageId: string) => {
    return useQuery({
        queryFn: ({ signal }) => getOperationalStatus({ statusPageId, signal }),
        queryKey: ['operationalStatus', statusPageId],
        refetchInterval: 5 * 60 * 1000,
    });
};

export { useGetOperationalStatus };
